import type { DoorSignStatus } from "@shared/types/foyer";

/**
 * Door-sign copy. Fixed enum in v1 (per spec §4), localized at the render layer.
 * Swedish first-class since the care segment is Swedish-facing ("Hemvist");
 * everything else falls back to English. Custom/operator-editable labels are a
 * later increment.
 */
function isSwedish(locale?: string): boolean {
  return (locale ?? "").toLowerCase().startsWith("sv");
}

export function statusLabel(status: DoorSignStatus, locale?: string): string {
  const sv = isSwedish(locale);
  switch (status) {
    case "resting":
      return sv ? "Vilar" : "Resting";
    case "knock":
      return sv ? "Knacka gärna" : "Please knock";
    case "do-not-disturb":
      return sv ? "Stör ej" : "Do not disturb";
    case "out":
      return sv ? "Ute" : "Out";
    default:
      return "";
  }
}

export function presenceLabel(occupied: boolean, locale?: string): string {
  const sv = isSwedish(locale);
  if (occupied) return sv ? "Inne" : "Occupied";
  return sv ? "Ledigt" : "Vacant";
}

/** Kicker above the room number. */
export function roomKicker(locale?: string): string {
  return isSwedish(locale) ? "RUM" : "ROOM";
}
